import { render, staticRenderFns } from "./Suspension.vue?vue&type=template&id=2f14fdbc&scoped=true&"
import script from "./Suspension.vue?vue&type=script&lang=js&"
export * from "./Suspension.vue?vue&type=script&lang=js&"
import style0 from "./Suspension.vue?vue&type=style&index=0&id=2f14fdbc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f14fdbc",
  null
  
)

export default component.exports